import { useLocation, useNavigate } from 'react-router-dom';

import { PATHS } from '@/shared/constants/routes/paths';
import { PricingEntryPoint } from '@/shared/lib/pricingAttribution';

export const useOpenPricingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (pricingEntryPoint: PricingEntryPoint) =>
    navigate(`/${PATHS.pricing}`, {
      state: { path: `${location.pathname}${location.search}${location.hash}`, pricingEntryPoint },
    });
};
